<template>
  <La1 :style="{}" :ratio="'1fr 1.3fr'" class="prodSet">
    <template slot="left">
      <div class="T">
        商品選項
      </div>
      <div class="field">
        <div>*類別名稱</div>
        <input type="text" placeholder="類別名稱" v-model="name">
      </div>
      <div class="field" :style="{marginTop: '43px'}">
        <div>*輸入選項 <span class="note">*點擊標籤可刪除選項</span></div>
        <div class="tags" @click="$refs.tag.focus()">
          <div v-for="(opt, o) in items" :key="`opt-${o}`" @click.stop="items.splice(o, 1)">{{opt}}</div>
          <input type="text" placeholder="選項標籤" ref="tag"
          v-model="itemEdit"
          @keypress.enter="items.push(itemEdit);itemEdit=null">
        </div>
      </div>
      <Btns :style="{marginTop: '26px', justifyContent: 'flex-end'}"
      @save="save" @cancel="name=null;items=[]"/>
    </template>
      <div class="rightT">
        選項列表
      </div>
      <Tables :rows="options" :style="{tableLayout: 'fixed'}">
        <template slot="slot_head">
          <th :style="{textAlign: 'start', width: '260px'}">名稱</th>
          <th :style="{textAlign: 'start', width: '-webkit-fill-available'}">選項</th>
          <th :style="{width: '60px'}">刪除</th>
          <th :style="{width: '60px'}"></th>
        </template>
        <tr slot-scope="{item,index}" :style="{height:'64px'}">
          <td @click="name=item.name;items=item.items" :style="{textAlign: 'start', width: '160px'}">{{item.name}}</td>
          <td @click="name=item.name;items=item.items" :style="{textAlign: 'start'}">{{item.items.join(' / ')}}</td>
          <td :style="{width: '60px'}"><DelBtn :style="{margin: 'auto'}" @click="deleteItem={name:item.name,_id:item._id, index}"/></td>
          <td :style="{width: '60px'}"></td>
        </tr>
      </Tables>
      <comfirmVue :show="!!deleteItem"  v-if="!!deleteItem" :label="'確認刪除'" :text='`確定要刪除"${deleteItem.name}"嗎?`' @confirm="del(deleteItem._id, deleteItem.index)" @cancel="deleteItem=null"/>
  </La1>
</template>

<script>
import DelBtn from '../../../components/btn/del.vue'
import Btns from '../../../components/btn/btns.vue'
import Tables from '../../../components/tables/t2.vue'
import La1 from '../../../components/layout/La1.vue'
import { deleteapi, getapi, putapi } from '../../../store/fetch'
export default {
  components: {
    La1,
    Btns,
    Tables,
    DelBtn
  },
  data () {
    return {
      deleteItem: null,
      items: [],
      name: null,
      options: [],
      itemEdit: null
    }
  },
  async mounted () {
    await this.getdata()
  },
  methods: {
    async getdata () {
      this.options = await getapi('options')
    },
    async del (id, index) {
      await deleteapi(`options/${id}`)
      this.options.splice(index, 1)
      this.deleteItem = null
    },
    async save () {
      const items = this.items
      if (!this.name) {
        return false
      }
      if (this.itemEdit) {
        items.push(this.itemEdit)
      }
      if (items.length === 0) {
        return false
      }
      const r = await putapi(`options/${this.name}`, { items: items })
      this.options.splice(0, 0, r)
      this.name = null
      this.items = []
      this.itemEdit = null
    }
  }

}
</script>
<style lang="scss">
.prodSet {
  .La1_right {
    border-left: 1px solid #CACACA;
  }
  .La1_left {
    padding-inline: 60px;
  }
  tr {
    border-bottom: 1px solid #C4C4C4;
  }
}
</style>
<style lang="scss" scoped>
.field {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  &>div:nth-child(1) {
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: var(--color-checked);
    .note {
      margin-left: 20px;
      font-weight: 400;
      font-size: 16px;
      line-height: 180%;
      color: #787878;
    }
  }
  &>input[type=text] {
    margin-top: 12px;
    width: 100%;
    border: none;
    border-bottom: 1px solid #CACACA;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 46;
    letter-spacing: 0.05em;
    height: 46px;
  }
  .tags {
    margin-top: 5px;
    width: 100%;
    min-height: 170px;
    border: 1px solid var(--color-checked);
    border-radius: 5px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    padding: 12px 17px;
    gap: 10px;
    &>div {
      font-size: 20px;
      padding: 5px 8px;
      border: 1px solid var(--color-checked);
    }
    input[type=text] {
      height: 40px;
      width: 200px;
      font-weight: 400;
      font-size: 20px;
      line-height: 150%;
      letter-spacing: 0.05em;
      color: #B9B9B9;
      border: none;
    }
  }
}
.T {
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 500;
  font-size: 28px;
  line-height: 150%;
  letter-spacing: 0.05em;
  color: var(--color-checked);
}
.rightT {
  height: 76px;
  padding-inline: 46px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
    font-weight: 500;
    font-size: 28px;
    line-height: 150%;
    letter-spacing: 0.05em;
    color: var(--color-checked);

}
</style>
